import { getContext, setContext } from 'svelte';

export type FieldRegistration = {
	getError: () => string | null;
	touch: () => void;
	isTouched: () => boolean;
	reset: () => void;
	tabValue?: string;
	focus?: () => void;
};

export type FormContext = {
	register: (name: string, field: FieldRegistration) => void;
	unregister: (name: string) => void;
	showAllErrors: () => boolean;
};

const FORM_CONTEXT_KEY = Symbol.for('@form-context');

export function setFormContext(ctx: FormContext): void {
	setContext(FORM_CONTEXT_KEY, ctx);
}

export function getFormContext(): FormContext | undefined {
	return getContext<FormContext | undefined>(FORM_CONTEXT_KEY);
}
